import {
    GET_ADMIN_LISTING,
    GET_ADMIN_LISTING_SUCCESS,
    GET_ADMIN_LISTING_FAIL,
    GET_ADMIN_DETAILS,
    GET_ADMIN_DETAILS_SUCCESS,
    GET_ADMIN_DETAILS_FAIL,
    ADD_ADMIN,
    ADD_ADMIN_SUCCESS,
    ADD_ADMIN_FAIL,
    UPDATE_ADMIN,
    UPDATE_ADMIN_SUCCESS,
    UPDATE_ADMIN_FAIL,
    DELETE_ADMIN,
    DELETE_ADMIN_SUCCESS,
    DELETE_ADMIN_FAIL,
    EXPORT_ADMIN,
    EXPORT_ADMIN_SUCCESS,
    EXPORT_ADMIN_FAIL,
    RESET_ADMIN_STATE,
    RESET_ADMIN_ACTION_STATE,
    UPDATE_ADMIN_PASSWORD_FAIL,
    UPDATE_ADMIN_PASSWORD_SUCCESS,
    UPDATE_ADMIN_PASSWORD,
} from "./actionTypes";

export const getAdminListing = (payload) => ({
    type: GET_ADMIN_LISTING,
    payload: payload
});

export const getAdminListingSuccess = categories => ({
    type: GET_ADMIN_LISTING_SUCCESS,
    payload: categories,
});

export const getAdminListingFail = error => ({
    type: GET_ADMIN_LISTING_FAIL,
    payload: error,
});

export const getAdminDetails = adminId => ({
    type: GET_ADMIN_DETAILS,
    payload: adminId,
});

export const getAdminDetailsSuccess = admin => ({
    type: GET_ADMIN_DETAILS_SUCCESS,
    payload: admin,
});

export const getAdminDetailsFail = error => ({
    type: GET_ADMIN_DETAILS_FAIL,
    payload: error,
});

export const createAdmin = admin => ({
    type: ADD_ADMIN,
    payload: admin,
});

export const createAdminSuccess = admin => ({
    type: ADD_ADMIN_SUCCESS,
    payload: admin,
});

export const createAdminFail = error => ({
    type: ADD_ADMIN_FAIL,
    payload: error,
});

export const updateAdmin = admin => ({
    type: UPDATE_ADMIN,
    payload: admin,
});

export const updateAdminSuccess = admin => ({
    type: UPDATE_ADMIN_SUCCESS,
    payload: admin,
});

export const updateAdminFail = error => ({
    type: UPDATE_ADMIN_FAIL,
    payload: error,
});

export const updateAdminPassword = admin => ({
    type: UPDATE_ADMIN_PASSWORD,
    payload: admin,
});

export const updateAdminPasswordSuccess = admin => ({
    type: UPDATE_ADMIN_PASSWORD_SUCCESS,
    payload: admin,
});

export const updateAdminPasswordFail = error => ({
    type: UPDATE_ADMIN_PASSWORD_FAIL,
    payload: error,
});

export const deleteAdmin = ({ id, multiple }) => ({
    type: DELETE_ADMIN,
    payload: { id, multiple },
});

export const deleteAdminSuccess = adminId => ({
    type: DELETE_ADMIN_SUCCESS,
    payload: adminId,
});

export const deleteAdminFail = error => ({
    type: DELETE_ADMIN_FAIL,
    payload: error,
});

export const exportAdmin = (payload) => ({
    type: EXPORT_ADMIN,
    payload: payload
});

export const exportAdminSuccess = data => ({
    type: EXPORT_ADMIN_SUCCESS,
    payload: data,
});

export const exportAdminFail = error => ({
    type: EXPORT_ADMIN_FAIL,
    payload: error,
});

//reset
export const resetAdminState = () => {
    return {
        type: RESET_ADMIN_STATE,
    }
}
//reset attachment
export const resetAdminActionState = () => {
    return {
        type: RESET_ADMIN_ACTION_STATE,
    }
}

